import {LabelObjType} from '@crema/types/models/apps/ScrumbBoard';

const labelList: LabelObjType[] = [
  {id: 301, name: 'High Priority', type: 1, color: 'red'},
  {id: 302, name: 'Important', type: 2, color: 'green'},
  {id: 303, name: 'Crema', type: 3, color: '#0A8FDC'},
  {id: 304, name: 'Work Place', type: 4, color: 'rgb(229, 231, 235)'},
];
export default labelList;
